import { render, staticRenderFns } from "./premio.vue?vue&type=template&id=183113a5&scoped=true&"
import script from "./premio.vue?vue&type=script&lang=js&"
export * from "./premio.vue?vue&type=script&lang=js&"
import style0 from "./premio.vue?vue&type=style&index=0&id=183113a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183113a5",
  null
  
)

export default component.exports